import React from 'react';
import PayrollManagement from '../PayrollManagement';

const EmployeePayrollPage = () => {
  return <PayrollManagement />;
};

export default EmployeePayrollPage;
